const changeLocUiName = (name: string): string => {
  const nameMap: Record<string, string> = {
    "Bengaluru / Bangalore": "Bengaluru",
    "Bangalore / Bengaluru": "Bengaluru",
    "Hyderabad / Secunderabad, Telangana": "Hyderabad",
    "Hyderabad / Secunderabad - Telangana": "Hyderabad",
    "Gurgaon / Gurugram": "Gurugram",
    "Gurugram / Gurgaon": "Gurugram",
  };

  return nameMap[name] || name;
};

export const getLocationData = (locations: any): string => {
  if (!locations || !Array.isArray(locations)) return "";

  const locationsArray = locations
    .map((location: any) => {
      if (location.city) return changeLocUiName(location.city);
      if (location.state) return changeLocUiName(location.state);
      if (location.country) return changeLocUiName(location.country);
      return null;
    })
    .filter(Boolean);

  return locationsArray.join(", ");
};
